import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";

export default function ViewBattle({
  openBattleView,
  handleClose,
  selectedItem,
}) {
  return (
    <Dialog
      open={openBattleView}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth // Ensures the dialog uses the full width of maxWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "500px",
        },
      }}
    >
      <DialogTitle style={{ fontSize: "20px", width: "200px", color: "black" }}>
        Battle Details
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ fontSize: "18px" }} mb={1}>
          Title: <span style={{ fontWeight: 400 }}>{selectedItem?.title}</span>
        </Typography>
        {/* <Typography variant="body1" sx={{ fontSize: "18px" }}>
          Category:{" "}
          <span style={{ fontWeight: 400 }}>
            {viewDetails.category?.name || "N/A"}
          </span> 
        </Typography>*/}
        <Typography variant="body1" sx={{ fontSize: "18px" }} mb={1}>
          Start Date:
          <span style={{ fontWeight: 400 }}>
            {" "}
            {dayjs(selectedItem.startDate).format("DD MMM YYYY - h:mm A")}
          </span>
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px" }} mb={1}>
          End Date:{" "}
          <span style={{ fontWeight: 400 }}>
            {dayjs(selectedItem.endDate).format("DD MMM YYYY - h:mm A")}
          </span>
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px" }} mb={1}>
          Turn Duration:{" "}
          <span style={{ fontWeight: 400 }}>{selectedItem?.turnDuration}</span>
        </Typography>
        {/* Show category logo */}
        {selectedItem.logo ? (
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography variant="body1" sx={{ fontSize: "18px" }}>
              Logo:&nbsp;
            </Typography>
            <img
              src={selectedItem.logo}
              alt="Category Logo"
              style={{
                maxWidth: "100px",
                maxHeight: "100px",
                objectFit: "contain",
              }}
            />
          </Box>
        ) : (
          <Typography variant="body1">No Logo</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
